import { Component } from "@angular/core";
import { PageGenericActionItem } from "./page-generic-action-item";

@Component({
  selector: "page-generic-action-separator",
  template: "",
  providers: [
    {
      provide: PageGenericActionItem,
      useExisting: PageGenericActionSeparatorComponent
    }
  ],
  standalone: false
})
export class PageGenericActionSeparatorComponent {}
